import React, { useEffect, useState, useRef, useContext } from "react";
import { baseRequest } from "../../../axiosconfig";
import { formatListToMap } from "../../../utils/formatters";
import { hasUnitEditPermission } from "../../../utils/permissions";
import "./businessprocesses.css";
import DropdownWrapper from "../../elements/dropdownWrapper";

import PoslovniProcessTable from "../../poslovniProcessTable";
import PoslovniProcessOwnerTable from "../../poslovniProcesiOwnerTable";

import DropDown from "../../elements/dropDown";
import Loading from "../../loading";
import { useNavigate, Link } from "react-router-dom";
import NewPoslovniProces from "../../newPoslovniProces/indesx";
import NavigatePopup from "../../navigatePopup";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { PRINT_PAGE_STYLE } from "../../../utils/printPageStyle";
import TestPrintPoslovniProcesi from "../../poslovniProcessTable/testprintprocesi";
import DeleteMapaPopup from "../../deleteMapaPopup";
import { UserContext } from "../../../userContext";
import { UnsavedDataContext } from "../../../context";
import { ROLES } from "../../../constants/roles";
import { downloadFile } from "../../../utils/download";
import ImportProcesa from "../importProcesa";
import {
  pickSignatures,
  buildSignaturesPayload,
} from "../../../utils/businessProcessSignatures";

export const hasProcessPermission = hasUnitEditPermission;

export default function AdminBusinessProcesses() {
  const [organization_units, setOrganization_units] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);
  // uvoz iz Excela (samo Administrator); reloadKey ponovo učitava podatke posle uvoza
  const [showImport, setShowImport] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [activeUnit, setActiveUnit] = useState(null);
  const [activeProcess, setActiveProcess] = useState();
  const [businessProcessList, setBusinessProcessList] = useState();
  const [newUnit, setNewUnit] = useState();
  const [newProcess, setNewProcess] = useState();
  const [errorMessages, setErrorMessages] = useState();
  const [errorObject, setErrorObject] = useState();
  const [showNavigatePopup, setShowNavigatePopup] = useState(false);
  const [processToDelete, setProcessToDelete] = useState(null);
  // postojeća Lista čije brisanje čeka potvrdu (EXP-03)
  const [unitToDelete, setUnitToDelete] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filterOrganizationUnits, setFilterOrganizationUnits] = useState();
  const [signaturesDraft, setSignaturesDraft] = useState(null);

  const dropdownStyle = { width: "60%", borderRight: "var(--mainBorder)" };

  const navigate = useNavigate();
  const componentRef = useRef();

  const { user } = useContext(UserContext);
  const { setUnsavedData } = useContext(UnsavedDataContext);

  // Napuštanje strane briše oznaku nesačuvanih izmena
  useEffect(() => {
    return () => setUnsavedData(false);
  }, [setUnsavedData]);

  const calculateProcessOwnersNames = (list, des) => {
    if (!list || !list.length) return [];
    if (list.length) {
      if (list[0].label) {
        return list;
      } else {
        const names = list.map((owner) => {
          const worker = des.find((des) => {
            return des.id === owner.employee_id;
          });
          if (worker)
            return {
              value: { ...owner, name: worker.name },
              label: worker?.name,
              isDisabled: undefined,
            };
          // vlasnik koji više nije aktivan: ostaje prikazan iz postojeće reference,
          // ne nudi se u listi za izbor; uklanja se tek svesnom izmenom
          const name = `${owner.first_name || ""} ${owner.last_name || ""}`.trim();
          if (!name) return undefined;
          const label = `${name} (nije više aktivan)`;
          return {
            value: { ...owner, name: label },
            label,
            isDisabled: undefined,
          };
        });

        return names.filter((name) => name);
      }
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: PRINT_PAGE_STYLE,
  });

  useEffect(() => {
    setLoading(true);
    const urls = [
      "/employee/id/0/level/0",
      "/organization_unit/0",
      "/business_processes",
    ];
    Promise.all(
      urls.map((url) => baseRequest.get(url))
    )
      .then((res) => {
        setLoading(false);

        const [employeesRes, unitsRes, processesRes] = res;
        const responseObj = {
          designations: formatDesignations(employeesRes.data.data || []),
          organization_units: unitsRes.data.data || [],
          business_processes: processesRes.data.business_processes || [],
        };
        if (responseObj.business_processes.length) {
          const actualUnits = responseObj.business_processes.filter(
            (el) => !el.del
          );
          setDesignations(responseObj["designations"]);
          setOrganization_units(responseObj["organization_units"]);
          const unit = actualUnits.length ? actualUnits[0] : null;

          if (unit) {
            setActiveUnit({
              ...unit,
              business_process_lists: unit.business_process_lists.map(
                (item) => {
                  return {
                    ...item,
                    business_process_owners: calculateProcessOwnersNames(
                      item.business_process_owners,
                      responseObj["designations"]
                    ),
                  };
                }
              ),
            });
          } else {
            setActiveUnit({});
          }

          setBusinessProcessList(
            formatListToMap(responseObj["business_processes"])
          );
        } else {
          setDesignations(responseObj["designations"]);
          setOrganization_units(responseObj["organization_units"]);

          setLoading(false);
          // bez Listi: prazno stanje sa uputstvom; nacrt se otvara tek na „+"
          setActiveUnit({});
          setBusinessProcessList({});
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, [reloadKey]);

  const handleSetEditPoslovniProcesItem = (payload) => {
    if (activeProcess || newProcess) {
      return;
    }
    setActiveUnit((unit) => {
      const newProcesses = unit.business_process_lists.map((item) => {
        if (payload.id === item.id) {
          return { ...item, editing: true };
        }
        return item;
      });
      return { ...unit, business_process_lists: newProcesses };
    });
    setActiveProcess(
      activeUnit.business_process_lists.find(
        (process) => payload.id === process.id
      )
    );
  };

  const handleChangeActiveProcessName = (e, id) => {
    if (errorObject?.code) {
      setErrorObject((errors) => {
        const { name, ...rest } = errors;
        return rest;
      });
    }
    setActiveUnit((unit) => {
      const newProcesses = unit.business_process_lists.map((item) => {
        if (id === item.id) {
          return { ...item, name: e.target.value.trimStart() };
        }
        return item;
      });
      return { ...unit, business_process_lists: newProcesses };
    });
    setActiveProcess((process) => {
      return { ...process, name: e.target.value.trimStart() };
    });
  };

  const handleCreateNewProcess = (payload) => {
    if (validateProcess(payload)) {
      return;
    }
    setLoading(true);
    const processOwners = (payload.business_process_owners || []).map((item) => {
      return { employee_id: item.value.id };
    });

    baseRequest
      .post(
        "/business_process_list",
        { ...payload, business_process_owners: processOwners }
      )
      .then((res) => {
        setLoading(false);
        setErrorMessages(null);
        setErrorObject(null);
        setActiveUnit((unit) => {
          return {
            ...unit,
            business_process_lists: [
              ...unit.business_process_lists,
              {
                ...res.data.data,
                business_process_owners: calculateProcessOwnersNames(
                  res.data.data.business_process_owners,
                  designations
                ),
              },
            ],
          };
        });

        setBusinessProcessList((list) => {
          return {
            ...list,
            [res.data.data.business_process_id]: {
              ...list[res.data.data.business_process_id],
              business_process_lists: list[res.data.data.business_process_id]
                .business_process_lists
                ? [
                    ...list[res.data.data.business_process_id]
                      .business_process_lists,
                    res.data.data,
                  ]
                : [res.data.data],
            },
          };
        });

        setNewProcess(null);
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessages(
          error.response?.data?.message || "Greška pri čuvanju procesa"
        );
      });
  };

  function formatDesignations(list) {
    return list.map((item) => {
      return {
        id: item.id,
        parent_id: item.parent_id,
        level: item.level,
        designation_id: item.designation_id,
        // ime i prezime su potrebni tabeli potpisa pre čuvanja (OwnerItem čita first_name/last_name)
        first_name: item.first_name,
        last_name: item.last_name,
        name: item.designation
          ? `${item.first_name} ${item.last_name} - ${item.designation.name}`
          : item.designation_name
          ? `${item.first_name} ${item.last_name} - ${item.designation_name}`
          : `${item.first_name} ${item.last_name}`,
        designation_name: item.designation
          ? item.designation.name
          : item.designation_name,
      };
    });
  }

  // Nova lista postoji samo lokalno dok korisnik ne izabere jedinicu; tek tada se
  // upisuje (POST sa jedinicom i nivoom), pa napuštanje ekrana ne ostavlja nacrt
  const emptyDraftUnit = () => ({
    id: null,
    level: -1,
    organization_unit_id: null,
    manager_employee_id: null,
    business_process_lists: [],
  });

  const handleAddNewUnit = () => {
    setActiveProcess(null);
    setNewProcess(null);
    setActiveUnit(emptyDraftUnit());
  };

  // Popunjena lista (ima žive stavke procesa) ne menja organizacionu jedinicu —
  // izbor jedinice je samo za nacrt / listu bez procesa
  const isPopulatedUnit = (unit) =>
    !!unit &&
    unit.level > -1 &&
    (unit.business_process_lists || []).some((item) => !item.del);

  const handleSelectUnit = ({ value }) => {
    setSignaturesDraft(null);
    setUnsavedData(false);
    setLoading(true);
    const body = {
      level: value.level,
      organization_unit_id: value.id,
      // promena jedinice briše prethodnog rukovodioca; bira se ponovo iz nove jedinice
      manager_employee_id: null,
    };

    // lokalni nacrt se upisuje tek sada, sa izabranom jedinicom
    const request = activeUnit.id
      ? baseRequest.put("/business_process", { ...body, id: activeUnit.id })
      : baseRequest.post("/business_process", body);

    request
      .then((res) => {
        setLoading(false);
        setActiveUnit((unit) => {
          return {
            ...unit,
            ...res.data.data,
          };
        });

        const acUnit = {
          ...activeUnit,
          ...res.data.data,
        };

        setBusinessProcessList((list) => {
          return { ...list, [acUnit.id]: acUnit };
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSetNewProcess = () => {
    setNewProcess({
      redniBroj: activeUnit?.business_process_lists.filter((el) => !el.del)
        .length
        ? activeUnit?.business_process_lists.filter((el) => !el.del).length + 1
        : 1,
      code: ``,
      name: "",
      business_process_owners: [],
      business_process_id: activeUnit.id,
      adding: true,
    });
  };

  const handleSelectDesignation = ({ value }) => {
    if (
      !Object.keys(activeUnit).length ||
      activeUnit.organization_unit_id === 0
    ) {
      return;
    }

    const payload = { ...activeUnit, manager_employee_id: value.id };
    setLoading(true);

    baseRequest
      .put("business_process", payload)
      .then((res) => {
        setLoading(false);

        setActiveUnit((unit) => {
          return { ...unit, ...res.data.data };
        });
        setBusinessProcessList((list) => {
          return {
            ...list,
            [res.data.data.id]: { ...activeUnit, ...res.data.data },
          };
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleChangeNewProcess = (e) => {
    if (errorObject?.name) {
      setErrorObject((errors) => {
        const { name, ...rest } = errors;
        return rest;
      });
    }
    setNewProcess((process) => {
      return { ...process, name: e.target.value.trimStart() };
    });
  };

  const handleSelectNewProcessOwners = (value) => {
    const owners = value || [];
    setNewProcess((process) => {
      return { ...process, business_process_owners: owners };
    });

    if (owners.length && errorObject?.business_process_owners) {
      setErrorObject((errors) => {
        const { business_process_owners, ...rest } = errors;
        return rest;
      });
    }
  };

  const handleSelectProcessOwner = (id) => {
    return function (value) {
      const owners = value || [];
      if (owners.length && errorObject?.business_process_owners) {
        setErrorObject((errors) => {
          const { business_process_owners, ...rest } = errors;
          return rest;
        });
      }
      setActiveUnit((unit) => {
        const newProcesses = unit.business_process_lists.map((process) => {
          if (process.id === id) {
            return {
              ...process,
              business_process_owners: value,
              editingOwners: true,
            };
          }
          return process;
        });
        return {
          ...unit,
          business_process_lists: newProcesses,
        };
      });
    };
  };

  const handleUpdateProcess = (payload) => {
    // Validacija i priprema pre spinnera: greška u pripremi ne sme da ostavi overlay
    if (validateProcess(payload)) {
      return;
    }
    const formattedOwners = (payload.business_process_owners || []).map((owner) => {
      // izabran vlasnik je { value, label }; neformatiran zapis sa servera je sam vlasnik
      const value = owner?.value || owner || {};
      return {
        ...value,
        employee_id: value.employee_id ? value.employee_id : value.id,
      };
    });

    setLoading(true);
    baseRequest
      .put(
        "/business_process_list",
        { ...payload, business_process_owners: formattedOwners }
      )
      .then((res) => {
        setErrorObject(null);
        setErrorMessages(null);
        const newOwners = calculateProcessOwnersNames(
          res.data.data.business_process_owners,
          designations
        );
        setActiveUnit((unit) => {
          return {
            ...unit,
            business_process_lists: unit.business_process_lists.map((pr) => {
              if (pr.id === res.data.data.id) {
                return { ...res.data.data, business_process_owners: newOwners };
              }
              return pr;
            }),
          };
        });
        setBusinessProcessList((list) => {
          return {
            ...list,
            [res.data.data.business_process_id]: {
              ...list[res.data.data.business_process_id],
              business_process_lists: list[
                res.data.data.business_process_id
              ].business_process_lists.map((pr) => {
                if (pr.id === res.data.data.id) {
                  return res.data.data;
                }
                return pr;
              }),
            },
          };
        });
        setActiveProcess(null);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleDeleteNewProcess = () => {
    setErrorMessages(null);
    setErrorObject(null);
    setNewProcess(null);
  };

  const handleDisableOrganizationUnits = (units) => {
    if (businessProcessList) {
      const newUnits = units.map((unit) => {
        const a = Object.values(businessProcessList).find(
          (val) =>
            val.organization_unit_id === unit.id &&
            val.level === unit.level &&
            !val.del
        );
        if (a || hasProcessPermission(user, unit.id, unit.level) === false) {
          return { ...unit, isDisabled: true };
        }
        return unit;
      });

      return newUnits;
    } else {
      return units;
    }
  };

  const allUnitsDisabled = (units) => {
    return handleDisableOrganizationUnits(units).every((un) => un.isDisabled);
  };

  const validateProcess = (process) => {
    const owners = process.business_process_owners || [];
    if (!process.name || !owners.length || !process.code) {
      if (!process.name) {
        setErrorObject((errors) => {
          return { ...errors, name: true };
        });
      }
      if (!process.code) {
        setErrorObject((errors) => {
          return { ...errors, code: true };
        });
      }
      if (!owners.length) {
        setErrorObject((errors) => {
          return { ...errors, business_process_owners: true };
        });
      }
      setErrorMessages("Popunite sva obavezna polja");
      return true;
    }
  };

  // Brisanje traži potvrdu (kao kod zaposlenih i mapa procesa)
  const handleDeleteProcess = (id) => {
    setProcessToDelete(id);
  };

  const handleConfirmDeleteProcess = () => {
    const id = processToDelete;
    setLoading(true);
    baseRequest
      .delete(`/business_process_list/${id}`)
      .then(() => {
        setLoading(false);
        setProcessToDelete(null);
        // red se samo označava kao obrisan; sirov odgovor servera nema
        // formatirane vlasnike pa bi srušio prikaz (print komponenta)
        setActiveUnit((unit) => {
          const newProcesses = unit.business_process_lists.map((process) => {
            if (process.id === id) {
              return { ...process, del: true };
            }
            return process;
          });
          return { ...unit, business_process_lists: newProcesses };
        });
        setBusinessProcessList((list) => {
          const newProcesses = list[activeUnit.id].business_process_lists.map(
            (process) => {
              if (process.id === id) {
                return { ...process, del: true };
              }
              return process;
            }
          );

          return {
            ...list,
            [activeUnit.id]: {
              ...list[activeUnit.id],
              business_process_lists: newProcesses,
            },
          };
        });
        if (newProcess) {
          const newProcessRednibroj = activeUnit.business_process_lists.filter(
            (proc) => !proc?.del
          ).length
            ? activeUnit.business_process_lists.filter((proc) => !proc?.del)
                .length + 1
            : 1;

          setNewProcess((process) => {
            return { ...process, redniBroj: newProcessRednibroj - 1 };
          });
        }
      })
      .catch(() => {
        setLoading(false);
        setProcessToDelete(null);
      });
  };

  const handleDeleteUnit = (id) => {
    if (!id) {
      // lokalni nacrt: odbacuje se bez zahteva i bez potvrde; vraća se prva
      // postojeća jedinica, sa vlasnicima formatiranim kao pri učitavanju (QA-A-01)
      const remaining = Object.values(businessProcessList || {}).filter(
        (unit) => unit && !unit.del && unit.level > -1
      );
      const first = remaining[0];
      setActiveUnit(
        first
          ? {
              ...first,
              business_process_lists: (first.business_process_lists || []).map(
                (process) => ({
                  ...process,
                  business_process_owners: calculateProcessOwnersNames(
                    process.business_process_owners,
                    designations
                  ),
                })
              ),
            }
          : {}
      );
      setActiveProcess(null);
      setNewProcess(null);
      return;
    }
    // postojeća Lista: brisanje tek posle potvrde (EXP-03)
    setUnitToDelete(id);
  };

  const handleConfirmDeleteUnit = () => {
    const id = unitToDelete;
    setLoading(true);
    baseRequest
      .delete(`/business_process/${id}`)
      .then((res) => {
        setLoading(false);
        setUnitToDelete(null);

        setBusinessProcessList((list) => {
          const { activeUnitsNumber, activeUnits } = findActiveUnits(list);
          if (id === activeUnit.id) {
            if (
              activeUnitsNumber === 1 &&
              activeUnit.organization_unit_id !== 0
            ) {
              setActiveUnit(null);
              setActiveProcess(null);
            } else {
              setActiveUnit(activeUnits[0]);
            }
          }

          return { ...list, [id]: res.data.data };
        });
      })
      .catch(() => {
        setLoading(false);
        setUnitToDelete(null);
      });
  };

  const handleNavigate = () => {
    navigate("/register/formulari-rizika");
  };

  const findActiveUnits = (list) => {
    const activeUnits = Object.values(list).filter((item) => item.del === 0);

    return { activeUnitsNumber: activeUnits.length, activeUnits };
  };

  const handleChangeProcessCode = (e, id) => {
    if (errorObject?.code) {
      setErrorObject((errors) => {
        const { code, ...rest } = errors;
        return rest;
      });
    }
    setActiveUnit((unit) => {
      const newProcesses = unit.business_process_lists.map((item) => {
        if (id === item.id) {
          return { ...item, code: e.target.value.trimStart() };
        }
        return item;
      });
      return { ...unit, business_process_lists: newProcesses };
    });
    setActiveProcess((process) => {
      return { ...process, code: e.target.value.trimStart() };
    });
  };
  const handleChangeNewProcessCode = (e) => {
    if (errorObject?.code) {
      setErrorObject((errors) => {
        const { code, ...rest } = errors;
        return rest;
      });
    }
    setNewProcess((process) => {
      return { ...process, code: e.target.value.trimStart() };
    });
  };

  // PRIPREMA / KONTROLIŠE / ODOBRAVA — izbor se čuva tek na „Sačuvajte tabelu potpisa"
  const canEditSignatures =
    Boolean(activeUnit && activeUnit.id && activeUnit.level >= 0 &&
      hasProcessPermission(user, activeUnit.organization_unit_id, activeUnit.level));

  const handleStartEditSignatures = () => {
    setErrorMessages(null);
    setSignaturesDraft(pickSignatures(activeUnit));
  };

  const handleChangeSignatureEmployee = (role) => (value) => {
    setUnsavedData(true);
    setSignaturesDraft((draft) => ({
      ...draft,
      [`${role}_employee_id`]: value.value.id,
      [role]: value.value,
    }));
  };

  const handleChangeSignatureDate = (field) => (value) => {
    setUnsavedData(true);
    setSignaturesDraft((draft) => ({ ...draft, [field]: value }));
  };

  const handleCancelSignatures = () => {
    setSignaturesDraft(null);
    setUnsavedData(false);
  };

  const handleSaveSignatures = () => {
    setLoading(true);
    baseRequest
      .put("business_process", buildSignaturesPayload(activeUnit, signaturesDraft))
      .then((res) => {
        setLoading(false);
        setErrorMessages(null);
        setActiveUnit((unit) => ({ ...unit, ...res.data.data }));
        setBusinessProcessList((list) => ({
          ...list,
          [res.data.data.id]: { ...list?.[res.data.data.id], ...res.data.data },
        }));
        setSignaturesDraft(null);
        setUnsavedData(false);
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessages(
          error?.response?.status === 403
            ? "Nemate ovlašćenje za ovu akciju."
            : "Tabela potpisa nije sačuvana. Pokušajte ponovo."
        );
      });
  };

  const filterUnitDesignations = (list, id, level) => {
    return list.filter((item) => {
      return item.parent_id === id && item.level === level;
    });
  };

  // Naziv iz liste aktivnih zaposlenih; ako zaposlenog više nema u listi
  // (obrisan posle izbora), ime se čita iz postojeće reference koju vraća server
  const calculateDesignationName = (list, id, employee, markInactive = true) => {
    const worker = list.find((item) => item.id === id);
    if (worker) return worker.name;
    const name = employee
      ? `${employee.first_name || ""} ${employee.last_name || ""}`.trim()
      : "";
    if (!name) return "";
    return markInactive ? `${name} (nije više aktivan)` : name;
  };

  const handleSelectActiveFilterUnit = ({ value }) => {
    setSignaturesDraft(null);
    setUnsavedData(false);
    const newValue = {
      ...value,
      business_process_lists: value.business_process_lists.map((process) => {
        return {
          ...process,
          business_process_owners: calculateProcessOwnersNames(
            process.business_process_owners,
            designations
          ),
        };
      }),
    };

    setActiveUnit(newValue);
  };

  return (
    <div>
      {user?.role_id === ROLES.SUPER_ADMIN && (
        <div
          className="processes-header"
          style={{ justifyContent: "flex-end", height: "51px", gap: "10px", paddingRight: "10px" }}
        >
          <button
            className="add-btn-large"
            title="Uvoz poslovnih procesa, mapa, procedura i rizika iz .xlsx fajla"
            style={{ fontSize: "12px", padding: "0 10px", whiteSpace: "nowrap", width: "auto" }}
            onClick={() => setShowImport(true)}
          >
            UVEZI IZ EXCELA
          </button>
          <button
            className="add-btn-large"
            title="Prazan šablon za uvoz procesa, mapa, procedura, koraka i rizika"
            style={{ fontSize: "12px", padding: "0 10px", whiteSpace: "nowrap", width: "auto" }}
            onClick={() =>
              downloadFile("/import/processes/template", "eFUK-sablon-procesi.xlsx")
            }
          >
            PREUZMITE ŠABLON
          </button>
          <button
            className="add-btn-large"
            title="Šablon popunjen primerom podataka (Služba računovodstva)"
            style={{ fontSize: "12px", padding: "0 10px", whiteSpace: "nowrap", width: "auto" }}
            onClick={() =>
              downloadFile("/import/processes/template?example=1", "eFUK-primer-procesi.xlsx")
            }
          >
            PREUZMITE PRIMER
          </button>
        </div>
      )}
      {showImport && (
        <ImportProcesa
          onClose={() => setShowImport(false)}
          onImported={() => setReloadKey((n) => n + 1)}
        />
      )}
      <div className="processes-header">
        <DropDown
          dropDownStyle={dropdownStyle}
          height={"49px"}
          list={
            businessProcessList
              ? Object.keys(businessProcessList)
                  .map((pr) => {
                    if (
                      businessProcessList[pr].level > -1 &&
                      !businessProcessList[pr].del
                    ) {
                      return businessProcessList[pr];
                    }
                  })
                  .filter((item) => item)
              : []
          }
          onChange={handleSelectActiveFilterUnit}
          selectedValue={activeUnit?.name}
        />
        {/* <div className="sort-options-dropdown" style={{ flex: 1 }}>
          <div
            className="sort-options-dropdown-selected"
            onClick={() => {
              setShowDropdown((state) => !state);
            }}
          >
            <span style={{ marginRight: "7px", paddingLeft: "10px" }}>
              Opcije
            </span>

            <img
              alt=""
              src="/images/sidebararrow.png"
              className="sidebar-navigation-item-arrow"
            ></img>
          </div>
          {showDropdown && (
            <ul
              className="sort-options-dropdown-options"
              style={{ left: "0", zIndex: "100", flex: 1 }}
            >
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setShowDropdown(false);
                }}
              >
                Izmenite
              </li>

              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  handlePrint();
                }}
              >
                Odštampaj
              </li>
            </ul>
          )}
        </div> */}
        <div style={{ marginRight: "10px", marginLeft: "10px" }}>
          {user && (
            <button className="add-btn-large" onClick={handlePrint}>
              <img alt="" src="/images/printer.png"></img>
            </button>
          )}
        </div>
        <div>
          <button
            className={
              (activeUnit && activeUnit.level === -1) ||
              !organization_units.length ||
              allUnitsDisabled(organization_units)
                ? "add-btn-large add-btn-large-disabled"
                : " add-btn-large"
            }
            onClick={handleAddNewUnit}
            disabled={
              (activeUnit && activeUnit.level === -1) ||
              !organization_units.length ||
              allUnitsDisabled(organization_units)
            }
          >
            <img alt="" src="/images/plus.png"></img>
          </button>
        </div>
      </div>

      {errorMessages && (
        <div className="errormessage" style={{ margin: "10px 0 0 50px" }}>
          {errorMessages}
        </div>
      )}
      {!loading && organization_units.length === 0 && (
        <div style={{ margin: "30px 50px", padding: "20px", border: "1px solid var(--mainColor)", borderRadius: "5px" }}>
          <p>Потребно је прво креирати организациону структуру пре додавања пословних процеса.</p>
          <Link to="/admin/struktura-preduzeca" style={{ color: "var(--mainColor)", fontWeight: "bold", marginTop: "10px", display: "inline-block" }}>
            Креирајте структуру предузећа
          </Link>
        </div>
      )}
      {!loading &&
        organization_units.length > 0 &&
        (!activeUnit || (!activeUnit.id && activeUnit.level !== -1)) && (
          // nema Liste za prikaz (prazna organizacija ili odbačen nacrt):
          // uputstvo zavisi od toga da li je „+" dostupan korisniku
          <div style={{ margin: "30px 50px", padding: "20px", border: "1px solid var(--mainColor)", borderRadius: "5px" }}>
            <p>
              {allUnitsDisabled(organization_units)
                ? "Nema Listi poslovnih procesa za koje imate pravo izmene."
                : "Još nema Listi poslovnih procesa. Kliknite „+\" i izaberite organizacionu jedinicu da napravite prvu Listu."}
            </p>
          </div>
        )}
      {activeUnit && (activeUnit.id || activeUnit.level === -1) && (
        <div
          className="poslovni-procesi-tables"
          style={{ width: "auto", margin: "20px 0 0 50px" }}
        >
          <DropdownWrapper
            title="organizaciona jedinica"
            wrapperStyle={{ borderBottom: "none" }}
            style={{ borderRight: "1px solid var(--mainColor)" }}
          >
            {isPopulatedUnit(activeUnit) ? (
              // popunjena Lista ne menja jedinicu: naziv kao običan tekst, bez
              // dropdown strelice (zaključan react-select izgleda kao aktivan)
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--mainColor)",
                  fontSize: 14,
                  padding: "0 10px",
                }}
              >
                {activeUnit?.name}
              </div>
            ) : (
              <DropDown
                list={handleDisableOrganizationUnits(organization_units)}
                onChange={handleSelectUnit}
                selectedValue={activeUnit?.name}
              />
            )}
          </DropdownWrapper>
          <DropdownWrapper
            title="Rukovodilac organizacione jedinice"
            style={{ borderRight: "1px solid var(--mainColor)" }}
          >
            <DropDown
              list={filterUnitDesignations(
                designations,
                activeUnit.organization_unit_id,
                activeUnit.level
              )}
              onChange={handleSelectDesignation}
              // isto pravo kao „+", potpisi i tabela procesa; server neovlašćen PUT odbija sa 403
              disabled={
                !hasProcessPermission(
                  user,
                  activeUnit.organization_unit_id,
                  activeUnit.level
                )
              }
              selectedValue={
                activeUnit?.employee
                  ? calculateDesignationName(
                      designations,
                      activeUnit.employee.id,
                      activeUnit.employee
                    )
                  : ""
              }
            />
          </DropdownWrapper>
          <div>
            <PoslovniProcessTable
              //ref={componentRef}
              designations={filterUnitDesignations(
                designations,
                activeUnit.organization_unit_id,
                activeUnit.level
              )}
              list={activeUnit.business_process_lists}
              handleDeleteProcess={handleDeleteProcess}
              handleSelectProcessOwner={handleSelectProcessOwner}
              handleSetEditPoslovniProcesItem={handleSetEditPoslovniProcesItem}
              handleChangeActiveProcessName={handleChangeActiveProcessName}
              handleUpdateProcess={handleUpdateProcess}
              errorObject={errorObject}
              activeProcess={activeProcess}
              handleChangeProcessCode={handleChangeProcessCode}
              newProcess={newProcess}
              activeUnit={activeUnit}
            />
            {newProcess && (
              <NewPoslovniProces
                process={newProcess}
                designations={designations}
                handleChangeNewProcess={handleChangeNewProcess}
                handleSelectNewProcessOwners={handleSelectNewProcessOwners}
                handleCretaeNewProcess={handleCreateNewProcess}
                handleDeleteNewProcess={handleDeleteNewProcess}
                errorObject={errorObject}
                handleChangeNewProcessCode={handleChangeNewProcessCode}
              />
            )}
            {hasProcessPermission(
              user,
              activeUnit.organization_unit_id,
              activeUnit.level
            ) && (
              <button
                className={
                  !activeUnit.id ||
                  activeUnit.organization_unit_id === 0 ||
                  newProcess ||
                  activeProcess
                    ? "add-poslovni-proces-btn add-poslovni-proces-btn-disabled"
                    : "add-poslovni-proces-btn"
                }
                onClick={handleSetNewProcess}
                disabled={
                  !activeUnit.id ||
                  activeUnit.organization_unit_id === 0 ||
                  newProcess ||
                  activeProcess
                }
                style={{ marginBottom: "20px" }}
              >
                <img src="/images/plus.png" />
                <span>Dodajte poslovni proces</span>
              </button>
            )}
          </div>
          <div style={{ paddingBottom: "3em", marginTop: "30px" }}>
            <PoslovniProcessOwnerTable
              employees={designations}
              preparedBy={(signaturesDraft || activeUnit).prepared_by}
              controlledBy={(signaturesDraft || activeUnit).controlled_by}
              approvedBy={(signaturesDraft || activeUnit).approved_by}
              preparedAt={(signaturesDraft || activeUnit).prepared_at}
              controlledAt={(signaturesDraft || activeUnit).controlled_at}
              approvedAt={(signaturesDraft || activeUnit).approved_at}
              onChangePreparedBy={handleChangeSignatureEmployee("prepared_by")}
              onChangeControlledBy={handleChangeSignatureEmployee("controlled_by")}
              onChangeApprovedBy={handleChangeSignatureEmployee("approved_by")}
              onChangePreparedAt={handleChangeSignatureDate("prepared_at")}
              onChangeControlledAt={handleChangeSignatureDate("controlled_at")}
              onChangeApprovedAt={handleChangeSignatureDate("approved_at")}
              disabled={!signaturesDraft}
            />
            {canEditSignatures && (
              <div style={{ display: "flex", gap: "30px" }}>
                {signaturesDraft ? (
                  <>
                    <button
                      className="add-poslovni-proces-btn"
                      onClick={handleSaveSignatures}
                    >
                      <img alt="" src="/images/save.png" />
                      <span>Sačuvajte tabelu potpisa</span>
                    </button>
                    <button
                      className="add-poslovni-proces-btn"
                      onClick={handleCancelSignatures}
                    >
                      <span>Odbacite izmene</span>
                    </button>
                  </>
                ) : (
                  <button
                    className="add-poslovni-proces-btn"
                    onClick={handleStartEditSignatures}
                  >
                    <img alt="" src="/images/edit.png" />
                    <span>Izmenite tabelu potpisa</span>
                  </button>
                )}
              </div>
            )}
            {hasProcessPermission(
              user,
              activeUnit.organization_unit_id,
              activeUnit.level
            ) && (
              <button
                className={
                  !(!activeUnit || !Object.keys(activeUnit).length)
                    ? "add-poslovni-proces-btn"
                    : "add-poslovni-proces-btn add-poslovni-proces-btn-disabled"
                }
                onClick={() => handleDeleteUnit(activeUnit.id)}
                disabled={!activeUnit || !Object.keys(activeUnit).length}
              >
                <img src="/images/trash.png" />
                <span>Izbrišite organizacionu jedinicu</span>
              </button>
            )}
          </div>
          <div style={{ display: "none" }}>
            <TestPrintPoslovniProcesi
              ref={componentRef}
              list={activeUnit.business_process_lists}
              activeUnit={activeUnit}
              designationName={
                activeUnit && activeUnit.employee
                  ? calculateDesignationName(
                      designations,
                      activeUnit.employee.id,
                      activeUnit.employee,
                      false
                    )
                  : ""
              }
            />
          </div>
        </div>
      )}
      {processToDelete && (
        <div className="loading">
          <DeleteMapaPopup
            setItemToDelete={setProcessToDelete}
            loading={loading}
            handleItemDelete={handleConfirmDeleteProcess}
          />
        </div>
      )}
      {unitToDelete && (
        <div className="loading">
          <DeleteMapaPopup
            setItemToDelete={setUnitToDelete}
            loading={loading}
            handleItemDelete={handleConfirmDeleteUnit}
          />
        </div>
      )}
      {showNavigatePopup && (
        <>
          <div className="loading"></div>
          <NavigatePopup
            setShowNavigatePopup={setShowNavigatePopup}
            handleNavigate={handleNavigate}
          />
        </>
      )}
      <Loading isLoading={loading} />
    </div>
  );
}
